import * as firebase from 'firebase/app'

import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/analytics'

const config = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
}

const app = firebase.initializeApp(config)

export default app

// if (process.env.IS_LOCAL) {
//     console.log(process.env.FIREBASE_AUTH_DOMAIN)
//     app.auth().useEmulator(process.env.FIREBASE_AUTH_DOMAIN)
//     app.firestore().useEmulator(
//         process.env.FIREBASE_FIRESTORE_HOST,
//         Number(process.env.FIREBASE_FIRESTORE_PORT)
//     )
// }
